import {
  takeLatest, call, put, select,
} from 'redux-saga/effects';
import axios from '../axiosConfig';
import {
  saveSendTripEmailRequest, saveSendTripEmailSuccess, saveSendTripEmailFailure,
  selectedCreditCard, doUseSavedCardForCheckout,
} from '../../slices/trip';
import formatTripRequest from '../../../helpers/formatTripRequest';
import getVGSProxyEndpoint from '../../../helpers/getVGSProxyEndpoint';
import { buildCreditCardPayment } from '../../../helpers/buildCreditCardPayment';
import { handleCardTokenization } from '../../../helpers/tokenizeCards';

const queryString = require('query-string');

function* saveSendTripEmailWorker({
  payload: {
    trip,
    customerEmail,
    customerPhoneNumber,
    tripStatus,
    doIncludeCC,
    doAllowSelfBookingTripQuote,
    messageToAdvisor,
    tokenizedCardMap,
    tokenizeFunc,
    isFormValid,
  },
}) {
  let tokenizedCardMapResult = tokenizedCardMap;

  try {
    const { email: loggedInUserEmail, isLoggedIn } = yield select((store) => store.user);
    const { creditCards } = yield select((store) => store.trip);
    const selectedCardForCheckout = yield select(selectedCreditCard);
    const doUseSavedCardForBooking = yield select(doUseSavedCardForCheckout);

    // Handle tokenization if needed
    if (!doUseSavedCardForBooking) {
      try {
        tokenizedCardMapResult = yield call(
          handleCardTokenization,
          tokenizeFunc,
          isFormValid,
          doUseSavedCardForBooking,
        );
      } catch (error) {
        yield put(saveSendTripEmailFailure(error.message));
        return;
      }
    }

    const qs = queryString.stringify({
      customerEmail,
      customerPhoneNumber,
      tripStatus,
      loggedInUserEmail,
      messageToAdvisor,
    }, { skipNull: true });
    const url = `${doIncludeCC && tokenizedCardMapResult ? '' : getVGSProxyEndpoint()}/email/saveSendTrip?${qs}`;
    const filters = yield select((store) => store.tripSearch.searchObj.cruise.filters);
    const staterooms = yield select((store) => store.tripSearch.searchObj.staterooms);

    const creditCardPayment = buildCreditCardPayment({
      doIncludeCC,
      doUseSavedCardForBooking,
      creditCards,
      tokenizedCardMapResult,
      isLoggedIn,
    });

    const config = {
      method: 'post',
      url,
      data: JSON.stringify({
        ...(formatTripRequest({
          trip,
          ...filters,
          staterooms,
        })),
        creditCardPayment,
        savedCreditCard: doIncludeCC && doUseSavedCardForBooking
          ? selectedCardForCheckout : undefined,
        doAllowSelfBookingTripQuote,
      }),
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const { data } = yield call(axios, config);
    if (data) {
      yield put(saveSendTripEmailSuccess());
    } else {
      yield put(saveSendTripEmailFailure('Could not send email, please try it again!'));
    }
  } catch (error) {
    let errorMsg = 'Could not send email, please try it again!';
    if (error.response && error.response.data && error.response.data.title) {
      errorMsg = `${error.response.data.title} ${error.response.data.detail}`;
    } else if (error && typeof (error) === 'object' && error.message) {
      errorMsg = `Could not send email, please try it again! ${error.name}: ${error.message} (${error.code}).`;
    }
    yield put(saveSendTripEmailFailure(errorMsg));
  }
}

function* saveSendTripEmailWatcher() {
  yield takeLatest(saveSendTripEmailRequest.toString(), saveSendTripEmailWorker);
}

export default saveSendTripEmailWatcher;
